import { NetworkRequestState } from '../../../networking/types';
import { TwoFactorAuthWidgetData, TwoFactorAuthWidgetStep } from './types';

export const defaultTwoFactorAuthWidgetState: TwoFactorAuthWidgetData = {
  canEnable: true,
  enabled: false,
  confirmed: false,
  secretUrl: '',
  secret: '',
  recoveryCodes: [],
  step: TwoFactorAuthWidgetStep.NotEnabled,
  request: {
    status: NetworkRequestState.IDLE,
    errors: {},
  },
};
